import { render, staticRenderFns } from "./ModalDebCredPixCPAY.vue?vue&type=template&id=8222808c&scoped=true&"
import script from "./ModalDebCredPixCPAY.vue?vue&type=script&lang=js&"
export * from "./ModalDebCredPixCPAY.vue?vue&type=script&lang=js&"
import style0 from "./ModalDebCredPixCPAY.vue?vue&type=style&index=0&id=8222808c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8222808c",
  null
  
)

export default component.exports